import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "../public/locales/en/translation.json";

const isTestEnv =
  typeof process !== "undefined" && process.env.NODE_ENV === "test";

if (isTestEnv) {
  void i18n.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    resources: { en: { translation: enTranslation } },
    initImmediate: false,
    showSupportNotice: false,
    interpolation: {
      escapeValue: false,
    },
  });
} else {
  void i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "en",
      debug: import.meta.env.DEV,
      showSupportNotice: false,
      interpolation: {
        escapeValue: false,
      },
    });
}

export default i18n;
